import React, { useEffect, useState } from "react";
import LoaderAnimation from "./LoaderAnimation";
import SecureLS from "secure-ls";
import MessageModal from "./MessageModal";
import { faCheckCircle, faClose } from "@fortawesome/free-solid-svg-icons";
import { mutate } from "swr";

const AttachClientToVoucherClient = ({ clientDataRedeemVoucher }) => {
  const [loading, setLoading] = useState(false);
  const [clientFirstName, setClientFirstName] = useState(
    clientDataRedeemVoucher?.field_first_name
  );
  const [clientLastName, setClientLastName] = useState(
    clientDataRedeemVoucher?.field_last_name
  );
  const [clientContact, setClientContact] = useState(
    clientDataRedeemVoucher?.field_contact_number
  );
  const [clientGender, setClientGender] = useState("");
  const [clientDateOfBirth, setClientDateOfBirth] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientLocation, setClientLocation] = useState("");

  const [isMessageModalVisibleAddRequest, setIsMessageModalVisibleAddRequest] =
    useState(false);
  const toggleModalClose = () => {
    setIsMessageModalVisibleAddRequest(false);
  };

  const ls = new SecureLS({ encodingType: "aes" });

  useEffect(() => {
    console.log(
      "clientDataRedeemVoucher???",
      clientDataRedeemVoucher?.voucher_nid
    );
  }, [clientDataRedeemVoucher]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const username = ls.get("username");
      const userpw = ls.get("userpw");
      const usercsrf_token = ls.get("usercsrf_token");

      if (!username || !userpw || !usercsrf_token) {
        alert("Missing credentials. Please log in again.");
        setLoading(false);
        return;
      }

      // ✅ Step 1: Check if voucher is expired
      const expirationDateStr =
        clientDataRedeemVoucher?.field_expiration_date?.[0]?.value;
      const voucherStatus = clientDataRedeemVoucher?.field_status?.[0]?.value;

      if (expirationDateStr && voucherStatus === "assigned") {
        const now = new Date();
        const expiryDate = new Date(expirationDateStr);

        if (now > expiryDate) {
          alert("This voucher has expired and cannot be redeemed.");
          setLoading(false);
          return;
        }
      }

      // ✅ Step 2: Continue updating client info if voucher is valid
      const clientdataRedeemPayload = {
        type: [{ target_id: "client" }],
        field_gender: [{ value: clientGender }],
        field_date_of_birth: [{ value: clientDateOfBirth }],
        field_client_email_address: [{ value: clientEmail }],
        field_location: [{ value: clientLocation }],
      };

      const response = await fetch(
        `${process.env.REACT_APP_SLASH_NODE_URL}/${clientDataRedeemVoucher.client_nid}?_format=json`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
            "Content-Type": "application/json",
            "X-CSRF-Token": usercsrf_token,
          },
          body: JSON.stringify(clientdataRedeemPayload),
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        if (response.status === 500 && responseData.message) {
          throw new Error(responseData.message);
        } else if (responseData.message) {
          throw new Error(responseData.message);
        } else {
          throw new Error("Failed to submit client data");
        }
      }

      // ✅ Step 3: Redeem voucher
      const updateVoucherResponse = await fetch(
        `${process.env.REACT_APP_SLASH_NODE_URL}/${clientDataRedeemVoucher?.voucher_nid}?_format=json`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
            "Content-Type": "application/json",
            "X-CSRF-Token": usercsrf_token,
          },
          body: JSON.stringify({
            type: [{ target_id: "voucher" }],
            field_status: [{ value: "redeemed" }],
          }),
        }
      );

      if (!updateVoucherResponse.ok) {
        const error = await updateVoucherResponse.json();
        console.error("Failed to update voucher status:", error);
        alert("Client was added, but failed to update voucher status.");
      } else {
        setIsMessageModalVisibleAddRequest(true);
        mutate(`${process.env.REACT_APP_VOUCHER_SCREENING_CONTENT_EDITOR_API}`);
        mutate(`${process.env.REACT_APP_VOUCHER_SCREENING_CLIENT_MANAGER_API}`);
      }

      // Clear fields
      setClientDateOfBirth("");
      setClientGender("");
      setClientContact("");
      setClientLocation("");
      setClientFirstName("");
      setClientLastName("");
      setClientEmail("");
    } catch (error) {
      console.error("Error:", error);
      alert(error.message || "An error occurred while submitting the form");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoaderAnimation />;
  }

  return (
    <div className="add-ctscan-request-register">
      <form onSubmit={handleSubmit} className="patient-form">
        <div className="form-group">
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            placeholder="Enter first name"
            value={clientFirstName}
            disabled
            // onChange={(e) => setClientFirstName(e.target.value)}
            // required
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            placeholder="Enter last name"
            value={clientLastName}
            disabled
            // onChange={(e) => setClientLastName(e.target.value)}
            // required
          />
        </div>
        <div className="form-group">
          <label htmlFor="contact">Contact Number</label>
          <input
            type="tel"
            placeholder="Enter contact number"
            value={clientContact}
            disabled
            // onChange={(e) => setClientContact(e.target.value)}
            // required
          />
        </div>
        <div className="form-group">
          <label htmlFor="gender">Gender</label>
          <select
            value={clientGender}
            onChange={(e) => setClientGender(e.target.value)}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="dob">Date of Birth</label>
          <input
            type="date"
            value={clientDateOfBirth}
            onChange={(e) => setClientDateOfBirth(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            placeholder="Enter email address"
            value={clientEmail}
            onChange={(e) => setClientEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            placeholder="Enter location"
            value={clientLocation}
            onChange={(e) => setClientLocation(e.target.value)}
            required
          />
        </div>
        <div className="submitGroup">
          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>

      {isMessageModalVisibleAddRequest && (
        <MessageModal
          leftIcon={faCheckCircle}
          color="green"
          fontSize={20}
          message="Voucher redeemed successfully!"
          onClose={toggleModalClose}
          rightIcon={faClose}
        />
      )}
    </div>
  );
};

export default AttachClientToVoucherClient;
